import React from 'react';
import { useQuery } from '@apollo/client';
import BASKET_QUERY from 'app/graphql/network/basket/basketQuery';
import { DELIVERY_BASKET_QUERY } from 'app/graphql/network/deliveryCart';

import { selectedPeriodVar } from 'app/apollo/reaction';
import { useBasketData } from './accessors';
import { useDeliveryBasketData } from './accessors/useDeliveryBasketData';

export const useBasketQueryLocate = () => {
    const isDeliveryBasket = window.location.pathname.includes('app/delivery');
    const deliveryId = window.location.pathname.split('/').find((e) => Boolean(e) && !Number.isNaN(Number(e)));

    const refetchBasket = () => {
        // alert('Отработал refetch из useBasketQueryLocate');
    };

    const newBasket = useBasketData();
    const deliveryBasket = useDeliveryBasketData();

    const cart = isDeliveryBasket
        ? [deliveryBasket, refetchBasket]
        : [newBasket, refetchBasket];
    return cart;
};
